module.exports = __webpack_public_path__ + "img/opinionlab-2018-workshop.c827917c.jpg";